<template>
  <div class="ma-0 pa-4 px-16 fill-height full-width main_container">
    <v-overlay :value="loading">
        <v-progress-circular color="#00C1B6" indeterminate size="64"></v-progress-circular>
    </v-overlay>
<!-- TITULO      -->
    <v-row dense class="mt-10 d-flex justify-space-between align-end">
      <span ref="titulo" class="titulo">
        Novo mercado de destino
      </span>
<!-- SALVAR      -->
      <span>
        <v-btn class="white--text mr-2" color="#00C1B6" @click="adicionando = true" :loading="adicionando">
          Adicionar nova mensagem
        </v-btn>
        <v-btn class="white--text" color="#00C1B6" @click="salvarMercadoDestino" :loading="salvando">Salvar</v-btn>
      </span>
    </v-row>
    <v-row dense class="mt-4 d-flex flex-column justify-space-between align-stretch">
      <span class="mb-1 label-nome-mercado">
        Nome
      </span>
<!-- NOME MERCADO DESTINO      -->
        <v-text-field solo placeholder="Informe o nome do mercado de destino"
                       v-model="mercadoDestino.dsMercadoDestino" :rules="dsMercadoDestinoErrors" />
    </v-row>
<!-- GRID MENSAGENS      -->
    <div class="pa-0 mt-4 d-flex flex-column align-stretch" >
      <v-row dense class="mb-0">
        <v-col class="ma-0 pa-0 pr-2">
<!-- ADICIONAR MENSAGEM      -->
          <v-expand-transition mode="out-in">
            <mensagem-mercado-destino-card v-if="adicionando" :mensagem.sync="novaMensagem"
                                           @deletarMensagem="limparNovaMensagem" :adicionando="adicionando"
                                           @novaMensagem="adicionarMensagem($event)"
            />
          </v-expand-transition>

<!-- LISTA MENSAGEM ESQ -->
          <mensagem-mercado-destino-card v-for="mensagem in listaMensagemMercadoDestinoEsq"
                                         :key="'mensagem_card_esq__' + mensagem.idMensagemBoletimSanitario"
                                         v-model="mercadoDestino.lstCdMensagemBoletimSanitario"
                                         :mensagem.sync="listaMensagemMercadoDestino[mensagem.id]"
                                         @deletarMensagem="deletarMensagem(mensagem.id)"
          />
        </v-col>
        <v-col cols="6" class="ma-0 pa-0 pl-2" >
<!-- LISTA MENSAGEM DIR -->
          <mensagem-mercado-destino-card v-for="mensagem in listaMensagemMercadoDestinoDir"
                                         :key="'mensagem_card_dir__' + mensagem.idMensagemBoletimSanitario"
                                         v-model="mercadoDestino.lstCdMensagemBoletimSanitario"
                                         :mensagem.sync="listaMensagemMercadoDestino[mensagem.id]"
                                         @deletarMensagem="deletarMensagem(mensagem.id)"
          />
        </v-col>
      </v-row>
      <v-row dense class="mb-16 d-flex justify-center align-end">
        <v-btn color="#e3e7e8" elevation="2" class="btn-voltar" rounded :to="{ name: 'mercadoDestino' }">
            <v-icon small class="mr-2">fa-arrow-left</v-icon>
            Voltar
        </v-btn>
        <v-pagination class="pb-0" color="#00C1B6" v-model="page" :length="totalPages" :total-visible="7" />
      </v-row>
    </div>
  </div>
</template>

<script>
import AlertSemDadosParaEtapa from "../AlertSemDadosParaEtapa";
import MensagemMercadoDestinoCard from "./MensagemMercadoDestinoCard";
import { validationMixin } from 'vuelidate';
import {MODELS, RULES, STRINGS} from "../../resources";
import {required} from "vuelidate/lib/validators";

export default {
  name: "DetalheMercadoDestino",
  components: {MensagemMercadoDestinoCard, AlertSemDadosParaEtapa},
	mixins: [validationMixin],
	validations() {
		return {
      mercadoDestino: {
          lstCdMensagemBoletimSanitario: {required},
          dsMercadoDestino: {required}
      },
    };
	},
  data: () =>({
    salvando: false,
    loading: false,
    adicionando: false,
    novaMensagem: new MODELS.MENSAGEM_MERCADO_DESTINO(),
		totalPages: 1,
		page: 1,
    listaMensagemMercadoDestino: [],
    mercadoDestino: new MODELS.MERCADO_DESTINO(),
  }),
  computed: {
    listaMensagemMercadoDestinoEsq() {
      return this.listaMensagemMercadoDestino.filter(
                (_, idx) => idx % 2 === 0)
    },
    listaMensagemMercadoDestinoDir() {
      return this.listaMensagemMercadoDestino.filter(
                (_, idx) => idx % 2 !== 0)
    },
    dsMercadoDestinoErrors() {
        let errors = [];
        if (!this.$v.mercadoDestino.dsMercadoDestino.$dirty) return errors;
        if (!this.$v.mercadoDestino.dsMercadoDestino.required) errors.push('Campo Obrigatório.');
        return errors;
    },
  },
  methods: {
    ...RULES,
    salvarMercadoDestino() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        if(this.$v.mercadoDestino.lstCdMensagemBoletimSanitario.$invalid)
          this.$store.commit("setSnack",{type: "error", msg: STRINGS.ObrigatorioSelecionarMensagem})

        return
      }

      this.salvando = true

      const configReq = this.mercadoDestino.idMercadoDestino > 0 ?
          {
            url: `mercado-destino/${this.mercadoDestino.idMercadoDestino}`,
            method: 'put',
            data: this.mercadoDestino,
          } :
          {
            url: 'mercado-destino/',
            method: 'post',
            data: this.mercadoDestino,
          }

      this.$axios.request(configReq)
        .then(res => {
          if (!res.data) return
          if (!res.data[0].data) return

          this.$store.commit("setSnack", {type: "success", msg: res.data[0].value})
          this.$router.push({ name: 'mercadoDestino' })
        })
        .catch(error => {
          this.$store.commit("setSnack", {type: "error", msg: error})
          this.salvando = false
        })
        .finally(() => {
          this.salvando = false
          this.editando = false
        })
    },
    deletarMensagem(idx) {
      this.listaMensagemMercadoDestino.splice(idx, 1)
      this.listaMensagemMercadoDestino = this.listaMensagemMercadoDestino.map((mensagem, idx) => _.extend(mensagem, {id: idx}))
    },
    limparNovaMensagem() {
      this.adicionando = false
      this.novaMensagem = new MODELS.MENSAGEM_MERCADO_DESTINO()
    },
    adicionarMensagem(mensagem) {
      this.listaMensagemMercadoDestino = [mensagem, ...this.listaMensagemMercadoDestino].map(
          (mensagem, idx) => _.extend(mensagem, {id: idx})
      )
      this.limparNovaMensagem()
    },
    async loadMercadoDestino(){
      if(!this.$route.params.idMercadoDestino || this.$route.params.idMercadoDestino < 1) return

      return this.$axios.get(`mercado-destino/${this.$route.params.idMercadoDestino}`)
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            const md = res.data[0].data

            this.mercadoDestino = new MODELS.MERCADO_DESTINO(
              md.dsMercadoDestino,
              md.idMercadoDestino,
              md.mensagensBoletimSanitario.map(mensagem => mensagem.idMensagemBoletimSanitario),
            )
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
    },
    async loadMensagemMercadoDestino(){
      return this.$axios.get('mensagem-boletim-sanitario/', { params: { page: this.page, per_page: 10 } })
          .then(res => {
            if (!res.data) return
            if (!res.data[0].data) return

            this.totalPages = res.data[0].meta.pages
            this.listaMensagemMercadoDestino = res.data[0].data.map((mensagem, idx) => _.extend(mensagem, {id: idx}))
          })
          .catch(error => {
            this.$store.commit("setSnack", {type: "error", msg: error})
            this.loading = false
          })
          .finally(() => {
            this.loading = false
          })
    },
  },
  watch: {
    page() {
      this.loadMensagemMercadoDestino()
    }
  },
  mounted() {
    this.loading = true
    let promises = []

    promises.push(this.loadMercadoDestino())
    promises.push(this.loadMensagemMercadoDestino())

    Promise.all(promises).then(() => this.loading = false)
  }
}
</script>

<style scoped>
.main_container {
  background-color: #f2f5f3;
  border-radius: 0 0 8px 8px;
}

.titulo {
  font: normal normal normal 32px/37px Roboto;
  color: #37565C;
  opacity: 0.8;
}

.label-nome-mercado {
  font: normal normal normal 12px/16px Roboto;
color: rgba(0, 0, 0, 0.6);
letter-spacing: 0.4px;
}

.no_select {
  user-select: none;
}

.card-pq-o-do-vuetify-da-ruim-no-ripple {
  background-color: white;
  border-radius: 8px;
}

.btn-voltar {
  position: absolute;
  left: 24px;
}
</style>